import { AutoMap } from "@automapper/classes";
import { mapper } from "../tools/mapping/mapper";
import { SamplingPointDTO } from "../services/dto/sampling-point.dto";
import { BaseDOM } from "./base.dom";

export class SamplingPoint extends BaseDOM<SamplingPoint> {

    Id?: number;
    @AutoMap()
    Code!: string;
    @AutoMap()
    Name!: string;
    @AutoMap()
    Address!: string;
    @AutoMap()
    City!: string;
    @AutoMap()
    ZipCode!: string;

}
